import { Data2, newId } from '../../../features/data-types'
import { useSystemStateHooks } from '../../system'
import { Driver } from '../state/types'

export const useDriverBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildDriver = (data: Data2) => {
        const { id = newId(), name, identifier, archived } = data
        const driver: Driver = {
            companyId: companyId!,
            id: id! as string,
            name: name! as string,
            identifier: identifier! as number,
            archived: !!archived
        }

        return driver
    }

    return {
        buildDriver
    }
}
